// Host rules mirror App\Support\WebsiteUrl in ai-agent-api (ENG-2323): every label is
// letters, digits or inner hyphens, the TLD is letters (or punycode), and after the host
// only a path, query or fragment may follow. No spaces, "@", ports or empty labels ("..").
// Surrounding whitespace is tolerated because the API trims it.
const HOST = String.raw`((?!-)[a-z\d-]{1,63}(?<!-)\.)+([a-z]{2,63}|xn--[a-z\d-]{1,59})`;
const TAIL = String.raw`([/?#]\S*)?`;

/** Business website typed by a user. The scheme is optional. */
export const WEBSITE_URL_PATTERN = new RegExp(String.raw`^\s*(https?:\/\/)?${HOST}${TAIL}\s*$`, 'i');

/** Links Rosie sends to callers (text link, booking link). Only https or no scheme. */
export const HTTPS_URL_PATTERN = new RegExp(String.raw`^\s*(https:\/\/)?${HOST}${TAIL}\s*$`, 'i');
